<script lang="ts">
    import type { RewardsStorefrontValuesBrandingEntity } from "@apps/rewards/entities/entities";

    export let rewardsBranding: RewardsStorefrontValuesBrandingEntity;

    const {
        general: { theme, buttons },
        popUpWidget: { launcher },
    } = rewardsBranding;
</script>

<div
    style:--gw-nudges-buttons__theme-color={theme[buttons.themeColor]}
    style:--gw-nudges-buttons__font-color={buttons.fontColor}
>
    <slot />
</div>
